import strings from '@/strings'

/* Order Status */
export const ORDER_STATUS_ERROR = 'E'
export const ORDER_STATUS_FIXED = 'F'
export const ORDER_STATUS_CORRECT = 'C'

/* Order States */
export const ORDER_STATE_RECEIVED = 'R'
export const ORDER_STATE_VALIDATED = 'V'
export const ORDER_STATE_TRANSMITTED = 'T'
export const ORDER_STATE_PENDING_TRANSMISSION = 'P'
export const ORDER_STATE_NOT_TRANSMITTED = 'N'
export const ORDER_STATE_FAIL = 'F'

/* Order Type of Search */
export const ORDER_SEARCH_BY_RECOLLECT = 'RI'

/* Exams */

export const EXAM_ORIGIN_RECOLLECT = 'R'
export const EXAM_ORIGIN_UPLOAD = 'U'
export const EXAM_ORIGIN_MANUAL = 'M'

/* Batches States */
export const BATCH_STATE_OPENED = 'OPENNED'
export const BATCH_STATE_PRINTED = 'CLOSED'

/* Batches Packaging States */
export const BATCH_TOTAL_PACKAGINGS = strings.packagingStatus.filter(x => x.active).length

export const BATCH_PACKAGING_FROZEN_ID = strings.packagingStatus.find(
  x => x.state === 'frozen'
).id
export const BATCH_PACKAGING_REFRIGERATED_ID = strings.packagingStatus.find(
  x => x.state === 'refrigerated'
).id
export const BATCH_PACKAGING_ROOM_TEMPERATURE_ID = strings.packagingStatus.find(
  x => x.state === 'room-temperature'
).id
export const BATCH_PACKAGING_REFRIGERATED_DRY_ID = strings.packagingStatus.find(
  x => x.state === 'refrigerated-dry'
).id

/* Batches System Source */
export const BATCH_SOURCE_SYSTEM_AOL2 = 'AOL2'
export const BATCH_SOURCE_SYSTEM_WS = 'AOLWS'

/* Spinner Progress from Orders */
export const SPINNER_TRANSFER_DEFAULT_MESSAGE = 'Transferindo ordens de serviço...'
export const SPINNER_TRANSFER_FIRST_TIMEOUT_SECONDS = 60
export const SPINNER_TRANSFER_FIRST_TIMEOUT_MESSAGE = 'Aguarde só mais alguns segundos...'
export const SPINNER_TRANSFER_SECOND_TIMEOUT_SECONDS = 120
export const SPINNER_TRANSFER_SECOND_TIMEOUT_MESSAGE =
  'O processo está mais lento que o normal. Pedimos que aguarde só mais um pouco.'
export const SPINNER_TRANSFER_COUNT_MILISECONDS = 1000
export const SPINNER_TRANSFER_TIMEOUT_MAX_SECONDS = 180

/* Dashboard */
export const DASHBOARD_INTERVAL_TIME_STAMP_MILISECONDS = 60000

export const DASHBOARD_INTERVAL_UPDATE_MILISECONDS = 300000

/* Traceability */
export const TRACEABILITY_SEARCH_PATIENT_NAME = 'PN'
export const TRACEABILITY_SEARCH_OS_ALVARO = 'OA'
export const TRACEABILITY_SEARCH_DATE = 'DT'
export const TRACEABILITY_SEARCH_STATUS = 'ST'
export const TRACEABILITY_SEARCH_SAMPLE = 'AM'
export const TRACEABILITY_SEARCH_OS_LIS = 'OL'
export const TRACEABILITY_SEARCH_BATCH = 'BA'
export const TRACEABILITY_SEARCH_NTO = 'NTO'
export const TRACEABILITY_SEARCH_PERIOD_DAYS_DEFAULT = 14
export const ALLOWED_STATUSES_FOR_INCLUD_EXAM_ACTIONS = [
  'AGUARDANDO_RETIRADA',
  'AMOSTRA_OBTIDA',
  'CADASTRADO',
  'COM_PENDENCIA',
  'EM_EXECUCAO',
  'EM_TRANSITO',
  'EM_TRANSITO_ENTRE_NTO',
  'NAO_LOTEADA_FISICAMENTE',
  'NAO_RASTREADO',
  'NAO_RECEBIDA',
  'PENDENCIA_CRIADA',
  'PENDENCIA_RESPONDIDA',
  'REMARCADO',
  'TRIAGEM',
]

export const ALLOWED_STATUSES_FOR_DELETE_EXAM_ACTIONS = [
  'AGUARDANDO_RETIRADA',
  'AMOSTRA_OBTIDA',
  'CADASTRADO',
  'NAO_LOTEADA_FISICAMENTE',
  'NAO_RASTREADO',
  'NAO_RECEBIDA',
  'EM_TRANSITO',
  'EM_TRANSITO_ENTRE_NTO',
  'TRIAGEM',
]

export const ALLOWED_STATUSES_FOR_UPDATE_COLLECT_DATE_EXAM_ACTIONS = [
  'AGUARDANDO_RETIRADA',
  'AMOSTRA_OBTIDA',
  'CADASTRADO',
  'NAO_LOTEADA_FISICAMENTE',
  'NAO_RASTREADO',
  'NAO_RECEBIDA',
  'EM_TRANSITO',
  'EM_TRANSITO_ENTRE_NTO',
  'TRIAGEM',
]

/* Pendencies */
export const PENDENCIES_PERIOD_DAYS_DEFAULT = 30
export const PENDENCIES_STATUS_PENDING = 'P'
export const PENDENCIES_STATUS_REPLIED = 'R'
export const PENDENCIES_STATUS_CANCELED = 'C'
export const PENDENCIES_ORDER_BY_PATIENT_NAME = 'PN'
export const PENDENCIES_ORDER_BY_STATUS = 'ST'
export const PENDENCIES_ORDER_BY_SEND_DATE = 'SD'
export const PENDENCIES_ORDER_BY_DEAD_LINE = 'DL'

/* Comunication bar */
export const MESSAGE_TYPE_PRODUCTION = 'P'
export const MESSAGE_TYPE_OPERATIONS = 'O'
export const MESSAGE_TYPE_FINANCE = 'F'
export const MESSAGE_TYPE_MARKETING = 'M'
export const MESSAGE_TYPE_NAC = 'N'
export const MESSAGE_TYPE_URGENT = 'U'

/* Recollects */
export const RECOLLECT_PENDING_STATUS = 'PENDENTE'
export const RECOLLECT_RESOLVED_STATUS = 'REALIZADO'
export const RECOLLECT_DISPENSED_STATUS = 'DISPENSADO_RECOLETAR'
export const RECOLLECT_DISPENSED_NEW_OS_STATUS = 'DISPENSADO_NOVA_OS'
export const RECOLLECT_PERIOD_DAYS_DEFAULT = 45

/* Results */
export const RESULTS_DATE_TYPE_RESULT_DATE = 'RD'
export const RESULTS_DATE_TYPE_TRANSFER_DATE = 'TD'

/* Collect Place */
export const COLLECTION_POINT_EMPTY_DEFAULT_VALUE = 'GERAL'

/* Results */
export const RESULTS_RECENTS_DAYS_RANGE = 4

/* Laudo Pdf */
export const LAUDO_PDF_PERIOD_DAYS_DEFAULT = 3

/* Panic Alert */
export const PANIC_ALERT_PERIOD_DAYS_DEFAULT = 30
